import React from "react";
// Import Helmet
import { Helmet } from "react-helmet"; 

// Define metadata constants for SEO
const PAGE_TITLE = "Login / Register | Steminorder Platform Access";
const PAGE_DESCRIPTION = "Log in or register for free access to the Steminorder global shipping and maritime trading platform.";
const CANONICAL_URL = "https://www.steminorder.com/login"; // Set to your login page path

const LoginPage = () => {
  return (
    <>
      {/* ============================================================
        REACT HELMET INTEGRATION 
        ============================================================
      */}
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        
        {/* Canonical URL */}
        <link rel="canonical" href={CANONICAL_URL} />

        {/* IMPORTANT: Use noindex, nofollow to prevent search engines from indexing 
          private or transactional pages like login/register forms. 
        */}
        <meta name="robots" content="noindex, nofollow" />

        {/* Open Graph tags are less critical here since the page is not meant to be shared, 
          but they can be included for completeness if the URL were somehow shared.
        */}
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Steminorder" />
      </Helmet>
      
      <div className="bg-login-pattern vh-100 vw-100">
        <div className="container py-16">
          <div className="row py-10">
            <div className="flex justify-center items-center">
              <img src={require("../images/logo.png")} alt="Steminorder Logo" />
            </div>
          </div>
          <div className="row">
            <div className="col-4 offset-4">
              <div className="card w-auto rounded-full">
                <div className="card-body rounded-full">
                  <ul
                    className="nav nav-tabs flex justify-around mb-4 row"
                    id="myTab"
                    role="tablist"
                  >
                    <li
                      className="nav-item col text-center text-base"
                      role="presentation"
                    >
                      <button
                        className="login-tab-items active text-breadcrumb"
                        id="login-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#login-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="login-tab-pane"
                        aria-selected="true"
                      >
                        Login
                      </button>
                    </li>
                    <li
                      className="nav-item col text-cente text-base"
                      role="presentation"
                    >
                      <button
                        className="login-tab-items"
                        id="register-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#register-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="profile-tab-pane"
                        aria-selected="false"
                      >
                        Register
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="login-tab-pane"
                      role="tabpanel"
                      aria-labelledby="login-tab"
                      tabIndex="0" // Changed tabindex to tabIndex for React compatibility
                    >
                      <div className="container">
                        <div className="row">
                          <h6 className="text-xl font-semibold">
                            Login with your credentials
                          </h6>
                        </div>
                        <div className="row">
                          <div className="my-3">
                            <label
                              htmlFor="emailInputLogin" // Changed for to htmlFor
                              className="form-label text-xs"
                            >
                              Email address
                            </label>
                            <input
                              type="email"
                              className="form-control border shadow-none"
                              id="emailInputLogin" // Unique ID
                              placeholder="name@example.com"
                            />
                          </div>
                          <div className="my-3">
                            <label
                              htmlFor="passwordInputLogin" // Changed for to htmlFor
                              className="form-label text-sxsm"
                            >
                              Password
                            </label>
                            <input
                              type="password"
                              className="form-control border shadow-none"
                              id="passwordInputLogin" // Unique ID
                              placeholder="*********"
                            />
                          </div>
                          <div className="my-3">
                            <button className="btn btn-primary w-100">
                              {" "}
                              Login
                            </button>
                          </div>
                          <div className="my-3 text-center">
                            <span className="text-xs text-center text-gray-400 font-medium">
                              Not a member?
                            </span>
                          </div>
                          <div className="my-3">
                            <button className="btn btn-primary-outline border border-header-green w-100">
                              Register Now
                            </button>
                          </div>
                          <div className="my-3 text-center">
                            <a
                              href="/"
                              className="login-href text-gray-700 text-xs underline"
                            >
                              {" "}
                              Back to HomePage
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="register-tab-pane"
                      role="tabpanel"
                      aria-labelledby="register-tab"
                      tabIndex="0" // Changed tabindex to tabIndex for React compatibility
                    >
                      <div className="container">
                        <div className="row">
                          <h4 className="text-xl font-semibold">
                            Register with your credentials
                          </h4>
                        </div>
                        <div className="row">
                          <div className="my-2">
                            <label
                              htmlFor="companyNameInput"
                              className="form-label text-xs"
                            >
                              Company Name
                            </label>
                            <input
                              type="email"
                              className="form-control border shadow-none"
                              id="companyNameInput"
                              placeholder="Enter your company name"
                            />
                          </div>
                          <div className="my-2">
                            <label
                              htmlFor="emailInputRegister"
                              className="form-label text-xs"
                            >
                              Email address
                            </label>
                            <input
                              type="email"
                              className="form-control border shadow-none"
                              id="emailInputRegister"
                              placeholder="name@example.com"
                            />
                          </div>
                          <div className="my-2">
                            <label
                              htmlFor="passwordInputRegister"
                              className="form-label text-xs"
                            >
                              Password
                            </label>
                            <input
                              type="password"
                              className="form-control border shadow-none"
                              id="passwordInputRegister"
                              placeholder="*********"
                            />
                          </div>
                          <div className="my-2">
                            <label
                              htmlFor="passwordRepeatInput"
                              className="form-label text-xs"
                            >
                              Re-enter Password
                            </label>
                            <input
                              type="password"
                              className="form-control border shadow-none"
                              id="passwordRepeatInput"
                              placeholder="*********"
                            />
                          </div>
                          <div className="my-2">
                            <button className="btn btn-primary w-100">
                              {" "}
                              Register
                            </button>
                          </div>
                          <div className="my-2 text-center">
                            <span className="text-xs text-center text-gray-400 font-medium">
                              Already a member?
                            </span>
                          </div>
                          <div className="my-2">
                            <button className="btn btn-primary-outline border border-header-green w-100">
                              Login Now
                            </button>
                          </div>
                          <div className="my-2 text-center">
                            <a
                              href="/"
                              className="login-href text-gray-700 text-xs"
                            >
                              {" "}
                              Back to HomePage
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;